import React from 'react';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Divider from '@material-ui/core/Divider';
import FormGroup from '@material-ui/core/FormGroup';
import Paper from '@material-ui/core/Paper';
import FilterPanelItem from './FilterPanelItem';

const useStyles = makeStyles(theme => ({
  panelPaper: {
    padding: `${theme.spacing(2)}px 0`,
    minWidth: '250px'
  },
  formGroupRoot: {
    paddingLeft: theme.spacing(2),
    flexWrap: 'nowrap',
    maxHeight: '250px',
    overflow: 'auto'
  },
  divider: {
    margin: `${theme.spacing(2)}px`
  },
  actionContainer: {
    margin: `0 ${theme.spacing(2)}px`,
    display: 'flex',
    justifyContent: 'flex-end',
    '& button': {
      marginLeft: theme.spacing(1)
    }
  }
}));

const FilterPanel = ({
  columnValues,
  selectedValues = [],
  onPanelClose = () => {},
  onFilterChange = () => {},
  onFilterClear = () => {}
}) => {
  const classes = useStyles();

  function isSelected(value) {
    return selectedValues.includes(value);
  }

  const toggleFilterValue = event => {
    const { checked, value } = event.target;
    let newSelectedValues = _.clone(selectedValues);
    if (checked) {
      newSelectedValues.push(value);
    } else {
      newSelectedValues = newSelectedValues.filter(
        filterValue => filterValue !== value
      );
    }
    onFilterChange(newSelectedValues);
  };

  if (columnValues.length === 0) {
    return null;
  }

  const sortedColumnValues = Object.keys(columnValues).sort();

  return (
    <Paper
      elevation={3}
      classes={{
        root: classes.panelPaper
      }}
    >
      <ClickAwayListener onClickAway={onPanelClose}>
        <div>
          <FormGroup classes={{ root: classes.formGroupRoot }}>
            {sortedColumnValues.map(columnValue => {
              const count = columnValues[columnValue];
              return (
                <FilterPanelItem
                  value={columnValue}
                  count={count}
                  selected={isSelected(columnValue)}
                  onChange={toggleFilterValue}
                  key={columnValue}
                />
              );
            })}
          </FormGroup>
          <Divider className={classes.divider} />
          <div className={classes.actionContainer}>
            <Button variant="text" onClick={onFilterClear}>
              <FormattedMessage id="table.columnFilterClearLabel" />
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={onPanelClose}
            >
              <FormattedMessage id="table.columnFilterOKLabel" />
            </Button>
          </div>
        </div>
      </ClickAwayListener>
    </Paper>
  );
};

export default FilterPanel;
